import React, { Component } from 'react';
import JSZip from 'jszip';
import { S3Client, ListObjectsV2Command, GetObjectCommand } from '@aws-sdk/client-s3';
import xiazai from '../../img/xiaZai.svg'
import { Spin, message } from 'antd';

const s3Client = new S3Client({
  region: 'cn-north-1',
  endpoint: 'https://obs-bj3.cucloud.cn',
  credentials: {
    accessKeyId: 'E383DF555D764B8885903A7EC513BFB32563',
    secretAccessKey: '0D84E3F444A54C62B9E8305D903E35E71221',
  },
  forcePathStyle: true,
  tls: true,
});

const BUCKET = 'qiyeweike';

class FolderDownload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            downloadedFiles: [],
            folderName: [], // 修改为要下载的文件夹路径
        };
    }

    componentDidUpdate (newProps) {
        if (newProps.selectdType !== this.props.selectdType) {
            this.setState({ folderName: this.props.selectdType })
        }
    }
    async downloadFolder () {
        const { folderName } = this.state;
        if(folderName.length){
            this.setState({loading:true})
        }else{
            return message.error('请选择要下载的文件')
        }

        let count = 0

        folderName.forEach(async item => {
            const downloadedFiles = await this.downloadFilesInFolder(s3Client, item)
            this.createZipAndDownload(downloadedFiles, item.split('/')[3]);
            count++
            if(count==folderName.length){
                this.setState({loading:false})
                message.success('下载结束')
                this.props.setSelectdType([])
                this.setState({folderName:[]})
            }
        })
    }

    async downloadFilesInFolder (client, folderPath) {
        const command = new ListObjectsV2Command({
            Bucket: BUCKET,
            Prefix: folderPath,
        });
        const result = await client.send(command);
        const objects = result.Contents || [];
        const downloadedFiles = [];
        for (const object of objects) {
            if (object.Key !== folderPath) {
                try{
                    const targetFile = object.Key.replace(folderPath, '');
                    const fileContent = await this.downloadFileInChunks(client, object.Key);
                    downloadedFiles.push({ name: targetFile, content: fileContent });
                }catch(error){
                    this.setState({loading:false})
                    message.error('下载失败')
                    console.log(error);
                }
            }
        }
        return downloadedFiles;
    }
    async downloadFileInChunks (client, filePath) {
        const command = new GetObjectCommand({
            Bucket: BUCKET,
            Key: filePath,
        });
        const result = await client.send(command);
        const stream = result.Body;
        const chunks = [];
        for await (const chunk of stream) {
            chunks.push(chunk);
        }
        const buffer = Buffer.concat(chunks);
        return new Blob([buffer], { type: result.ContentType });
    }
    async createZipAndDownload (files, fileName) {
        const zip = new JSZip();
        for (const file of files) {
            zip.file(file.name, file.content);
        }

        zip.generateAsync({ type: 'blob' })
            .then(function (content) {
                const zipBlob = new Blob([content], { type: 'application/zip' });
                const url = window.URL.createObjectURL(zipBlob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.zip`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            });
    }

    render () {
        const { downloadedFiles } = this.state;

        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <button style={{ backgroundImage: 'linear-gradient(90deg, #19A3F6 1%, #2077FF 100%)', borderRadius: ' 27.5px', border: 'none', width: '146px', height: '58px', color: '#FFFFFF', fontSize: '18px' }}
                        onClick={() => { this.downloadFolder(); }}> <img src={xiazai} alt="" /> 下载文件</button>
                    {/* <h1>Downloaded Files:</h1>
                <ul>
                    {downloadedFiles.map((file, index) => (
                        <li key={index}>{file.name}</li>
                    ))}
                </ul> */}
                </Spin>
            </div>
        );
    }
}

export default FolderDownload;
